import { render, staticRenderFns } from "./TheShareScreen.vue?vue&type=template&id=19fd0592&"
import script from "./TheShareScreen.vue?vue&type=script&lang=js&"
export * from "./TheShareScreen.vue?vue&type=script&lang=js&"
import style0 from "./TheShareScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports